import { render, staticRenderFns } from "./CastingAlloyComparison.vue?vue&type=template&id=cbf155e8&scoped=true"
import script from "./CastingAlloyComparison.vue?vue&type=script&lang=js"
export * from "./CastingAlloyComparison.vue?vue&type=script&lang=js"
import style0 from "./CastingAlloyComparison.vue?vue&type=style&index=0&id=cbf155e8&prod&scoped=true&lang=scss"
import style1 from "./CastingAlloyComparison.vue?vue&type=style&index=1&id=cbf155e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf155e8",
  null
  
)

export default component.exports